export default __webpack_public_path__ + "static/media/leather_handleAndStrap_NORM-min.0850175f.png";